import { useFetchAnyWorkspacePermissions } from '~/hooks/useFetchAnyWorkspacePermissions';
import { useCanViewPrivateAddOn } from '~/swr-hooks/workspaces/addOns/useCanViewPrivateAddOn';
import { canViewAddOns } from '~/utils/permissions/workspacePermissions';

/** Export CDN links is offered only when that add-on is turned on for the workspace. */
export const usePrivateWorkspaceAgentCdnLinksPromptCard = () => {
  const { data: permissions, isLoading: isPermissionsLoading } = useFetchAnyWorkspacePermissions();
  const { enabled: isCdnLinksEnabled, isLoading: isAddOnsLoading } = useCanViewPrivateAddOn({ key: 'cdnLinks' });
  const canCheckAddOns = canViewAddOns(permissions);

  return {
    isPending: isPermissionsLoading || (canCheckAddOns && isAddOnsLoading),
    isVisible: canCheckAddOns && isCdnLinksEnabled,
  };
};
